// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".pac-container{position:absolute!important;top:100%!important;left:0!important;width:100%!important;z-index:10000}", ""]);
// Exports
module.exports = exports;
